import React from 'react'
import { useStyles } from './styles'
import format from 'date-fns/format'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import { ValueScale, ArgumentScale } from '@devexpress/dx-react-chart'
import { scaleBand } from '@devexpress/dx-chart-core'
import { ArgumentAxis, ValueAxis, Chart, BarSeries, Title, Tooltip } from '@devexpress/dx-react-chart-material-ui'
import TitleText from './components/TitleText'
import ValueAxisLegend from './components/ValueAxisLegend'
import { PROGRESS_GRAPH_ROOT_CONTAINER_ID } from '../../../../utils/graphUtils'
import Bar from './components/Bar'
import MilestoneIcon from '../../../Icons/MilestoneIcon'
import Export from './components/Export'
import { EventTracker } from '@devexpress/dx-react-chart'

const StoriesGraph = ({ data: { learners }, type, filterName, assignedUsersToWaveCount }) => {
  const classes = useStyles()
  let chartData = []
  let nextMilestoneStepIndex = null
  let nextMilestoneDate = null
  if (learners.progress.path) {
    nextMilestoneStepIndex = learners.progress.path.goal.nextMilestoneStepIndex
    nextMilestoneDate = learners.progress.path.goal.nextMilestoneDate
    chartData = learners.progress.path.bySteps.steps.map((step, idx) => ({
      ...step,
      offset: idx + 1,
      pace:
        type === 'rate'
          ? idx < learners.progress.path.goal.minOnTrackStepIndex
            ? 'behind'
            : idx > learners.progress.path.goal.maxOnTrackStepIndex
            ? 'ahead'
            : 'onTrack'
          : null
    }))
  }

  return (
    <Grid container item xs={12} alignItems='center' justifyContent='space-between'>
      <Paper className={classes.chartBackground} id={PROGRESS_GRAPH_ROOT_CONTAINER_ID}>
        {learners.progress.path && learners.progress.path.bySteps.steps.length ? (
          <>
            <Chart data={chartData} className={classes.chart} height={250}>
              <ArgumentAxis tickSize={1} labelComponent={() => null} />
              <ArgumentScale factory={scaleBand} />
              <ValueScale modifyDomain={([min, max]) => [min, max ? max * 1.25 : 1]} />
              <Title text='Learner Progress' textComponent={TitleText} />
              <ValueAxis showGrid={false} showLine={true} tickFormat={() => tick => Number.isInteger(tick) ? tick : null} />
              <BarSeries
                valueField='value'
                argumentField='offset'
                pointComponent={Bar}
                barWidth={0.7}
                chartData={chartData}
                nextMilestoneStepIndex={nextMilestoneStepIndex}
              />
              <ValueAxisLegend />
              <EventTracker />
              <Tooltip />
              <Export />
            </Chart>
            <div className={classes.chartLegend}>
              <Typography variant='h5' component='div' className={classes.amount}>
                {`${
                  assignedUsersToWaveCount - learners.progress.path.bySteps.nonStartersCount - learners.progress.path.bySteps.finishersCount
                } Active learners`}
                {learners.progress.path.bySteps.nonStartersCount
                  ? ` • ${learners.progress.path.bySteps.nonStartersCount} Non-starters`
                  : null}
                {learners.progress.path.bySteps.finishersCount ? ` • ${learners.progress.path.bySteps.finishersCount} Finishers` : null}
              </Typography>
              {type === 'rate' ? (
                <div className={classes.rateLegend}>
                  <div className={classes.rateLegendLabel}>
                    <span className={classes.behind} />
                    <Typography variant='h5' component='div' className={classes.amount}>
                      Behind
                    </Typography>
                  </div>
                  <div className={classes.rateLegendLabel}>
                    <span className={classes.onTrack} />
                    <Typography variant='h5' component='div' className={classes.amount}>
                      On Track
                    </Typography>
                  </div>
                  <div className={classes.rateLegendLabel}>
                    <span className={classes.ahead} />
                    <Typography variant='h5' component='div' className={classes.amount}>
                      Ahead
                    </Typography>
                  </div>
                </div>
              ) : (
                <div className={classes.milestoneLegend}>
                  <Typography variant='h6' component='div' className={classes.milestoneLabel}>
                    NEXT MILESTONE
                  </Typography>
                  <MilestoneIcon />
                  <Typography variant='h6' component='div' className={classes.milestoneLabel}>
                    :
                  </Typography>
                  <Typography variant='h5' component='div' className={classes.milestoneValue}>
                    {nextMilestoneStepIndex ? `Step ${nextMilestoneStepIndex + 1} by ${format(nextMilestoneDate, 'LLLL do')}` : 'N/A'}
                  </Typography>
                </div>
              )}
            </div>
          </>
        ) : (
          <div className={classes.emptyGraph}>
            <Typography variant='h5' component='div' className={classes.topHeader}>
              Learner Progress
            </Typography>
            <div className={classes.icon}>
              <VisibilityOff />
            </div>
            <Typography variant='h5' component='div' className={classes.header}>
              This chart is disabled for this group!
            </Typography>
            <Typography variant='h5' component='div' className={classes.text}>
              Learner progress cannot be aggregated across the {filterName} group.
            </Typography>
          </div>
        )}
      </Paper>
    </Grid>
  )
}

export default StoriesGraph
